import { render, staticRenderFns } from "./Departament-form.vue?vue&type=template&id=16cac2fb"
import script from "./Departament-form.vue?vue&type=script&lang=js"
export * from "./Departament-form.vue?vue&type=script&lang=js"
import style0 from "./Departament-form.vue?vue&type=style&index=0&id=16cac2fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports